<template>
    <el-dialog title="图片管理" :visible.sync="dialogFormVisiblePicAdd" center @close="closeDialog">
            <el-tabs tab-position="left" @tab-click="handleClick" v-model="picTypeValue">
                <template v-for="item1 in pictureType">
                    <el-tab-pane :label="item1.typeName" :name="item1.typeId.toString()">
                        <div class="input-wrap">
                            <div class="search-wrap">
                                <el-input size="mini" placeholder="图片名称,搜索和上传都在这里" v-model="openUploadForm.imageName" clearable>
                                </el-input>
                                <el-upload
                                    multiple
                                    :disabled="openUploadForm.imageName==''?true:false"
                                    :data="openUploadForm"
                                    :with-credentials="true"
                                    :show-file-list="false"
                                    class="upload-demo"
                                    :action="saveUploadPath"
                                    :on-success="uploadSuccess"
                                >
                                    <el-button @click="fileBtn" type="success" size="mini">点击上传图片</el-button>
                                </el-upload>
                                <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                            </div>
                            <div>

                            </div>
                        </div>
                        <div class="pic-list-wrap" style="height: 500px;overflow-y: scroll">
                            <div v-for="(item,index) in pictureList" class="pic-list-item" :class="item.select?'pic-list-item-on':''">
                                <span>
                                    <el-image
                                        @close="closeImg"
                                        style="width: 100px; height: 100px;color: #ffffff"
                                        :src="item.allImagePath"
                                        :preview-src-list="[item.allImagePath]">
                                            </el-image>
<!--                                    <img :src="item.allImagePath" width="100" height="100">-->
                                </span>
                                <el-tooltip class="item" effect="dark" :content="item.imageName" placement="bottom">
                                    <p @click="selectPicture(item)">{{item.imageName}}</p>
                                </el-tooltip>
                                <i @click="delePicture(item,index)" class="el-icon-delete icon-del"></i>
                                <i @click="selectPicture(item)" class="icon-check" :class="item.select?'el-icon-check':''"></i>
                            </div>
                        </div>
                        <div class="pagination-wrap">
                            <el-pagination
                                hide-on-single-page
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="openUploadForm.currentPage"
                                :page-sizes="GCONFIG.pageSizes"
                                :page-size="openUploadForm.pageSize"
                                layout="total, sizes, prev, pager, next"
                                :total="totalRecord">
                            </el-pagination>
                        </div>

                    </el-tab-pane>
                </template>
            </el-tabs>
        <h5 class="sure-select-btn" v-show="fromState!='onlyOne'">
            <el-button type="danger" @click="ensurePicList">确认选择</el-button>
            已选择<b>{{selectFileList.length}}</b>张
        </h5>

    </el-dialog>
</template>

<script>
    import {saveImagepth} from '@/api/api'
    import draggable from 'vuedraggable'


    export default{
        data(){
            return {
                picTypeValue:'',
                picTypeValue1:'',
                openUploadForm: {
                    typeId: '',
                    imageName: "",
                    currentPage: 1,
                    pageSize: 20,
                    recordsTotal: 0,
                },
                formDetail: {
                    picType: '',
                    proId: '',
                    fullRelativeUrl: '',
                    allFullRelativeUrl:'',
                    sort:99
                },
                saveUploadPath:saveImagepth,
                selectFileList: []

            }
        },
        components:{
            draggable
        },
        props:['proId','picType','fromState'],
        computed:{
            dialogFormVisiblePicAdd:{
                get:function(){
                    return this.$store.state.picList.dialogFormVisiblePicAdd
                },
                set:function () {

                }
            },
            pictureType:function () {
                this.openUploadForm.typeId = this.picTypeValue;
                if(this.picTypeValue!=''){
                    this.$store.dispatch('initPictureList',{pageInfo:this.openUploadForm,selectList:this.selectFileList})
                }
                return this.$store.getters.getPictureType
            },
            pictureList:function () {
                return this.$store.getters.getPictureList.list
            },
            totalRecord:function () {
                return this.$store.getters.getPictureList.total
            },
        },
        mounted(){
            let _this = this;
            this.$store.dispatch('initPictureType').then(function (res) {
                console.log(res[0])
                _this.picTypeValue = res.length>0?res[0].typeId.toString():''
            });

        },
        methods:{
            closeDialog(){
                this.selectFileList = []
                this.$store.commit('SET_PIC_DIALOG',false)
            },
            handleSearch() {
                this.$store.dispatch('initPictureList',{pageInfo:this.openUploadForm,selectList:this.selectFileList})
            },
            handleSizeChange(val) {
                this.openUploadForm.pageSize = val
                this.$store.dispatch('initPictureList',{pageInfo:this.openUploadForm,selectList:this.selectFileList})
            },
            handleCurrentChange(val) {
                this.openUploadForm.currentPage = val
                this.$store.dispatch('initPictureList',{pageInfo:this.openUploadForm,selectList:this.selectFileList})
            },
            handleSelectChange(val){
                this.picTypeValue = val
            },
            uploadSuccess(res,file,fileList) {
                console.log(file)
                console.log(fileList)
                const loading = this.$loading(this.GCONFIG.loadingParam);
                loading.close();
                if (res.status == 200) {
                    this.$notify({
                        title: '成功',
                        message: '上传成功',
                        type: 'success'
                    });
                    this.openUploadForm.imageName = '';
                    this.$store.dispatch('initPictureList',{pageInfo:this.openUploadForm,selectList:this.selectFileList})
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    });
                }
            },
            selectPicture(row){
                this.$set(row,'select',!row.select)
                if(this.fromState=='onlyOne'){
                    this.$emit('selectPicOne',row)
                }else{
                    this.setSelectList()
                }

            },
            setSelectList(){
                this.selectFileList = this.pictureList.filter(item=>{
                    item.picType=this.picType
                    item.picId=item.imageId
                    item.proId=this.$route.params.id||this.proId
                    item.fullRelativeUrl=item.imagePath
                    item.picName=item.imageName
                    return item.select
                })
            },
            ensurePicList(){
                var params = {
                    'picListJson' : encodeURIComponent(JSON.stringify(this.selectFileList))
                };

                this.$store.dispatch('ensurePicList',params).then(res=>{
                    console.log(res)
                    if(res.status == 200){
                        this.selectFileList = [];
                        this.$store.commit('SET_PIC_DIALOG',false);
                        this.$store.dispatch('initPicture',{proId:this.$route.params.id||this.proId,picType:this.picType})
                    }
                })
            },
            delePicture(row,index){
                const _this = this;
                this.$confirm('删除图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center:true,
                    type: 'warning'
                }).then(() => {
                    _this.$store.dispatch('delPicListImg',{imageId: row.imageId}).then((res) => {
                        if (res.status == 200) {
                            _this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            _this.$set(row,'select',false)
                            _this.setSelectList()
                            _this.$store.dispatch('initPictureList',{pageInfo:_this.openUploadForm,selectList:_this.selectFileList})


                        } else {
                            _this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                    _this.$message({
                        showClose: true,
                        message: '取消删除',
                        type: 'error'
                    });
                })
            },
            handleClick(e){
                console.log(e,this.picTypeValue1)
            },
            fileBtn(e){
                console.log(12345)
                if(this.openUploadForm.imageName==''){
                    this.$alert('请先输入图片名称', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {

                        }
                    });
                }
            },
            closeImg(){
                console.log('close')
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .dialog-header{
        margin-bottom: 16px;
    }
    .select-pic-list{
        list-style: none;
        padding: 0 25px 0 10px;
        max-height: 374px;
        overflow-y: scroll;
        li{
            display: flex;
            justify-content: space-between;
            padding: 5px 0;
        }
    }
    .left-pic-container{
        h5{
            font-size: 14px;
            b{
                font-size: 16px;
            }
        }
        p{
            color: #e50011;
            font-size: 12px;
        }
    }
    .input-wrap{
        display: flex;
        margin-bottom: 30px;
        justify-content: space-between;
    }
    .search-wrap{
        display: flex;
    }
    .upload-demo{
        margin: 0 20px;
    }
    .sure-select-btn{
        text-align: center;
        font-size: 16px;
    }
    .pic-list-wrap{
        display: flex;
        flex-wrap: wrap;
        //justify-content: space-around;
        .pic-list-item{
            position: relative;
            width: 140px;
            text-align: center;
            margin: 0 10px 10px;
            padding: 6px 6px 0;
            border: 2px solid transparent;

            img{
                margin: 0 auto;
                display: block;
            }
            p{
                font-size: 12px;
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .icon-del{
                position: absolute;
                top: 0;
                left: 3px;
                display: none;
            }
            .icon-check{
                position: absolute;
                top: 2px;
                right: 2px;
                color: rgba(0,0,0,.4);
                font-size: 20px;
                font-weight: bolder;
                width: 20px;
                height: 20px;
                display: block;
                border: 1.5px solid;
                //border-radius: 20px;
            }
            &:hover{
                .icon-del{
                    display: block;
                }
            }
            &-on{
                color: #E6A23C;
                border: 2px solid;
                .icon-check{
                    color: #E6A23C;
                }
            }

        }
        .el-image-viewer__wrapper{
            color: #ffffff!important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pic_dialog/pic_list.vue